import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid2,
  TextField,
  Typography,
} from "@mui/material";
import { useCallback, useState } from "react";
import HighlightPlayer, {
  HighlightPlayerPersonalized,
} from "../../Components/VideoPlayer";
import HttpService from "../../Hooks/Https-services";
import { APIRoutes } from "../../Utils/constant";
import useConfig from "../../Hooks/useConfig";
import { useLoadData } from "../../Context/LoadDataContext";
import { LoadingButton } from "@mui/lab";

const NLPSearch = () => {
  const [nlpSearch, setNlpSearch] = useState("");
  const [finalSeach, setFinalSearch] = useState("");
  const [query, setQuery] = useState("");
  const { api } = useConfig();
  const [page, setPage] = useState<number>(1);
  const findCurrentClipTime = (el: any, index: any) => {
    let sum = 0;
    for (var i = 0; i < index; i++) {
      sum += parseFloat(videoClipsData?.list[i].duration) + 2;
    }
    return sum;
  };
  const { playerRef } = useLoadData();
  const [activeClip, setActiveClip] = useState("");
  const [videoClipsData, setVideoClipsData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const getQuery = useCallback(async () => {
    try {
      if (nlpSearch) {
        setLoading(true);

        const queryParam: any = {
          search: nlpSearch,
          cashedQuery: query,
          page: page,
        };
        const res = await HttpService.get(
          APIRoutes.GetNLPSeacrh +
            "?" +
            new URLSearchParams(queryParam).toString(),
        );
        setQuery(res?.data?.data?.query);
        setActiveClip(res.data.data?.list[0]?.game_event_id);
        const data = res.data.data?.list?.map((el: any) => {
          return {
            game_event_id: el.game_event_id,
            game_date: el.game_date,
            away_team_name: el.away_team?.team_name,
            home_team_name: el.home_team?.team_name,
            event_type: el.event_type,
            duration: el.duration,
          };
        });
        console.log(data);
        setVideoClipsData({
          list: data,
          isLastPage: res.data.data?.isLastPage,
          isFirstPage: res.data.data?.isFirstPage,
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }, [nlpSearch, page, query]);
  const handlePrevious = useCallback(async () => {
    console.log("Previous");
    setPage(page - 1);
    getQuery();
  }, [page, getQuery]);
  const handleNext = useCallback(async () => {
    console.log("Next");
    setPage(page + 1);
    getQuery();
  }, [page, getQuery]);
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
        }}
      >
        <TextField
          size="small"
          label="Search"
          multiline
          rows={3}
          onChange={(e) => {
            setNlpSearch(e.target.value);
            setQuery("");
            setPage(1);
          }}
          name="searchQuery"
          value={nlpSearch}
          sx={{
            my: 1,
            maxWidth: 300,
            width: 1,
          }}
        />
        <LoadingButton
          size="small"
          loading={loading}
          variant="contained"
          onClick={() => {
            setFinalSearch(nlpSearch);
            getQuery();
          }}
        >
          Search
        </LoadingButton>
        <Typography>{query}</Typography>
      </Box>
      {finalSeach && finalSeach.trim() && videoClipsData ? (
        <Box>
          <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12, md: 8 }}>
              <HighlightPlayerPersonalized
                url={`${api}/v1/assembly?event_ids=${videoClipsData?.list
                  ?.map((el: any) => el?.game_event_id)
                  .join(",")}&bypass=true`}
                videoList={videoClipsData?.list}
                setActiveClip={setActiveClip}
                findCurrentClipTime={findCurrentClipTime}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  bgcolor: "primary.main",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  variant="contained"
                  disabled={videoClipsData?.isFirstPage || loading}
                  onClick={handlePrevious}
                >
                  Previous
                </Button>
                <Button
                  variant="contained"
                  disabled={videoClipsData?.isLastPage || loading}
                  onClick={handleNext}
                >
                  Next
                </Button>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                {loading ? (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  videoClipsData?.list?.map((video: any, index: any) => (
                    <Box
                      onClick={() => {
                        playerRef.current.seek(
                          findCurrentClipTime(video, index),
                        );
                      }}
                      key={video.game_event_id}
                      sx={{
                        border:
                          activeClip === video.game_event_id
                            ? "1px solid red"
                            : "1px solid #e0e0e0",
                      }}
                    >
                      <Typography sx={{ px: 2, textAlign: "center" }}>
                        {video.event_type}
                      </Typography>
                      <Divider />
                      <Box
                        sx={{
                          display: "flex",

                          flexDirection: "column",
                          p: 1,
                          alignItems: "center",
                        }}
                      >
                        <Typography>{video.game_date}</Typography>
                        <Box sx={{ display: "flex", gap: 2 }}>
                          <Typography>{video.away_team_name}</Typography>
                          <Typography>AT</Typography>
                          <Typography>{video.home_team_name}</Typography>
                        </Box>
                      </Box>
                    </Box>
                  ))
                )}
              </Box>
            </Grid2>
          </Grid2>
        </Box>
      ) : (
        <Typography>Search Something</Typography>
      )}
    </Box>
  );
};
export default NLPSearch;
